<template>
    <section>
        <div class="section-inner">
            <div class="si-content" v-if="point">
                <div class="si-text">
                    <h2>{{ point.sub_title }}</h2>
                    <h1>{{ point.title }}</h1>
                    <p>{{ point.description }}</p>
                    <div class="si-text-bottom">
                        <div class="">
                            <p>{{ point.point_description }}</p>
                        </div>
                    </div>
                    <div class="si-text-stats">
                        <div class="sts-part">
                            <div class="sts-count">
                                <span>{{ point.doctor_point }}</span>
                            </div>
                            <div class="sts-text">
                                <span>{{ point.doctor_text }}</span>
                            </div>
                        </div>
                        <div class="sts-part">
                            <div class="sts-count">
                                <span>{{ point.nurse_point }}</span>
                            </div>
                            <div class="sts-text">
                                <span>{{ point.nurse_text }}</span>
                            </div>
                        </div>
                        <div class="sts-part">
                            <div class="sts-count">
                                <span>{{ point.patient_point }}</span>
                            </div>
                            <div class="sts-text">
                                <span>{{ point.patient_text }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="si-picture">
                    <div class="si-picture-img">
                        <img :src="point.img_url" alt="rs melinda 3"/>
                    </div>
                </div>
            </div>
        </div>
        <!-- <ServiceDetailSkeleton v-else/> -->
    </section>
</template>

<script setup>
    // import ServiceDetailSkeleton from '@/components/skeletons/sections/ServiceDetailSkeleton.vue';
    // import { useRoute } from 'vue-router';
    import { computed } from '@vue/reactivity';
    import { useHomeStore } from '@/stores/home';
    const point = computed(() => useHomeStore().point);
    // useHomeStore().setServiceDetail(useRoute().params.slug);
</script>

<style scoped>
    section{
        padding: 2.5rem 0 2.5rem 0;
        transition: 0.2s;
        background: var(--navy);
        color: var(--white);
    }
    .si-content{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: 0 10% 0 10%;
        /* color: var(--white); */
        transition: 0.2s;
        /* background: var(--navy); */
    }
    /* .cov-strip{
        display: flex;
        justify-content: left;
        padding: 1rem 0 0 0;
        transition: 0.2s;
    }
    .strip{
        width: 5%;
        height: 0.5rem;
        background: var(--red);
        transition: 0.2s;
    } */
    .si-text{
        width: 50%;
        padding: 0 1rem 0 0;
        /* color: var(--grey); */
    }
    .si-text h2{
        font-size: 1.1rem;
        color: var(--primary);
        margin: 0 0 0 0;
    }
    .si-text h1{
        font-size: 2rem;
        margin: 1rem 0 1rem 0;
        transition: 0.2s;
        color: var(--white);
    }
    .si-text-stats{
        display: flex;
        justify-content: center;
        text-align: center;
        padding: 1rem 0 1rem 0;
    }
    .sts-part{
        width: 33.33%;
    }
    .sts-count{
        font-size: 1.5rem;
        font-weight: 700;
    }
    .si-picture{
        width: 50%;
    }
    .si-picture-img{
        width: 100%;
    }
    .si-picture-img img{
        width: 100%;
    }
    @media only screen and (max-width: 1500px){
        section{
            padding: 2.5rem 0 2.5rem 0;
        }
        .si-content{
            padding: 0 5% 0 5%;
        }
    }
    @media only screen and (max-width: 750px){
        section{
            padding: 2.5rem 0 2.5rem 0;
        }
        .si-content{
            padding: 0 2.5% 0 2.5%;
        }
        .si-picture{
            width: 100%;
        }
        .si-text{
            width: 100%;
            padding: 0 0 2.5rem 0;
        }
        .si-text h1{
            font-size: 1.5rem;
        }
    }
</style>